import React, { useEffect, useState } from "react"
import dayjs from "dayjs"
import DashboardCard from "../../DashboardComponents/DashboardCard"
import { ICONS } from "../../../constants/icons"

const calculateCountdown = startDate => {
  const now = dayjs()
  const start = dayjs(startDate)
  if (!start.isValid() || start.isBefore(now)) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 }
  }

  const duration = start.diff(now, "second")
  const days = Math.floor(duration / (24 * 60 * 60))
  const hours = Math.floor((duration % (24 * 60 * 60)) / (60 * 60))
  const minutes = Math.floor((duration % (60 * 60)) / 60)
  const seconds = duration % 60

  return { days, hours, minutes, seconds }
}

/**
 * CountdownCard — Future (upcoming) project start countdown.
 * Compact single-row strip: label+icon | number boxes | duration
 */
const CountdownCard = ({ startDate, duration, projectName }) => {
  const [countdown, setCountdown] = useState(() =>
    calculateCountdown(startDate),
  )

  useEffect(() => {
    setCountdown(calculateCountdown(startDate))
    const interval = setInterval(() => {
      setCountdown(calculateCountdown(startDate))
    }, 1000)
    return () => clearInterval(interval)
  }, [startDate])

  const formatNumber = num => String(num).padStart(2, "0")

  const units = [
    { value: countdown.days, label: "Days" },
    { value: countdown.hours, label: "Hours" },
    { value: countdown.minutes, label: "Mins" },
    { value: countdown.seconds, label: "Secs" },
  ]

  return (
    <DashboardCard
      tone="peach"
      fullHeight={false}
      className="project-overview__countdown-card project-overview__countdown-card--strip"
    >
      <div
        className="project-overview__countdown-strip"
        aria-label="Countdown to project start"
      >
        {/* Left: icon + label + project name */}
        <div className="project-overview__countdown-info">
          <img
            src={ICONS.calendar}
            alt=""
            className="project-overview__countdown-info-icon"
            width={16}
            height={16}
          />
          <div className="project-overview__countdown-info-text">
            <span className="project-overview__countdown-info-label">
              Countdown to Project start
            </span>
            {projectName && (
              <span className="project-overview__countdown-info-project">
                {projectName}
              </span>
            )}
          </div>
        </div>

        {/* Center: number boxes */}
        <div className="project-overview__countdown-main">
          {units.map((unit, i) => (
            <React.Fragment key={unit.label}>
              <div className="project-overview__countdown-unit">
                <span className="project-overview__countdown-value">
                  {formatNumber(unit.value)}
                </span>
                <span className="project-overview__countdown-label">
                  {unit.label}
                </span>
              </div>
              {i < units.length - 1 && (
                <span
                  className="project-overview__countdown-separator"
                  aria-hidden="true"
                >
                  :
                </span>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Right: duration */}
        <div className="project-overview__countdown-duration">
          <span className="project-overview__countdown-duration-label">
            Project Duration
          </span>
          <span className="project-overview__countdown-duration-value">
            {duration.start} → {duration.end}
          </span>
        </div>
      </div>
    </DashboardCard>
  )
}

export default CountdownCard
